import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import { getUser } from '../../helpers/userStorage';

import Button from '@material-ui/core/Button';

import * as actionsGroupList from '../account.duck';

import TextField from '@material-ui/core/TextField';

import { Dialog } from '../../hooks/useDialog';


const Main = (props) => {
    const { account, actions } = props;

    var [currentPW, currentPW_set] = React.useState("");
    var [newPW, newPW_set] = React.useState("");
    var [newPW2, newPW2_set] = React.useState("");

    var [showPasswordReset, showPasswordReset_set] = React.useState(false);

    var user = getUser();

    const pwMatch = newPW.length > 0 && newPW2.length > 0 ? newPW === newPW2 ? true : false : true;


    if (!user) {
        return <div></div>;
    }

    console.log(account);

    return <div>
        <div style={{ marginBottom: 10, color: '#3f51b5' }}>Email Address</div>
        <div style={{ display: 'flex' }}>
            {user.authType === 'Facebook' && <div>
                <svg viewBox="0 0 18 18" id="icon-facebook-ico" width="20px"><g fill="none" fillRule="evenodd"><path fill="#4267B2" d="M17.007 0H.993A.993.993 0 0 0 0 .993v16.014c0 .548.445.993.993.993h8.628v-6.961H7.278V8.314H9.62V6.31c0-2.324 1.421-3.59 3.494-3.59.699-.002 1.397.033 2.092.105v2.43h-1.428c-1.13 0-1.35.534-1.35 1.322v1.735h2.7l-.35 2.725h-2.365V18h4.593a.993.993 0 0 0 .993-.993V.993A.993.993 0 0 0 17.007 0z"></path><path fill="#FFF" d="M12.182 18v-6.833h2.37l.354-2.674h-2.724V6.79c0-.774.222-1.298 1.362-1.298H15V3.104A20.657 20.657 0 0 0 12.886 3c-2.094 0-3.522 1.243-3.522 3.525v1.968H7v2.674h2.364V18h2.818z"></path></g></svg>
            </div>}
            {user.authType === 'Google' && <div>
                <svg viewBox="0 0 18 18" id="icon-google-ico" width="20px"><g fill="none" fillRule="evenodd"><path fill="#4285F4" d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"></path><path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"></path></g></svg>
            </div>}
            <div style={{ marginLeft: 10, fontSize: 14 }}>{user.email}</div>
        </div>
        {user.authType !== 'Default' && <div style={{ marginTop: 30 }}>
            Your account was created through an external provider. You can only change your password through your account provider (Google/Facebook).
        </div>}

        {showPasswordReset && <div>
            <Dialog
                title="Reset Password"
                options={{
                    fullWidth: true,
                    maxWidth: 'sm'
                }}
                actionButtons={[
                    <Button color={'primary'} disabled={account.passwordResetting || !pwMatch || !newPW || !newPW2 || !currentPW} onClick={() => {
                        actions.submitUserPasswordReset({ password: currentPW, newPassword: newPW });
                    }}>Reset Password</Button>,
                    <Button color='secondary' onClick={() => showPasswordReset_set(false)}>
                        Cancel
                    </Button>
                ]}>
                <div style={{ marginTop: 20 }}>Current Password</div>
                <div>
                    <TextField
                        id="current-password"
                        // placeholder="Email"
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        type="password"
                        value={currentPW}
                        onChange={(event) => {
                            currentPW_set(event.target.value);
                        }}
                        style={{ marginTop: 5 }}
                        inputProps={{
                            style: {
                                padding: 10,
                            }
                        }}
                        disabled={account.passwordResetting}
                    />
                </div>
                <div>New Password</div>
                <div>
                    <TextField
                        id="new-password"
                        // placeholder="Email"
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        type="password"
                        style={{ marginTop: 5 }}
                        inputProps={{
                            style: {
                                padding: 10,
                            }
                        }}
                        value={newPW}
                        onChange={(event) => {
                            newPW_set(event.target.value);
                        }}
                        disabled={account.passwordResetting}
                    />
                </div>
                <div>Confirm New Password</div>
                <div>
                    <TextField
                        id="new-password-confirm"
                        // placeholder="Email"
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        type="password"
                        style={{ marginTop: 5 }}
                        inputProps={{
                            style: {
                                padding: 10,
                            }
                        }}
                        value={newPW2}
                        onChange={(event) => {
                            newPW2_set(event.target.value);
                        }}
                        helperText={!pwMatch && 'Both passwords must be identical'}
                        error={!pwMatch}
                        disabled={account.passwordResetting}
                    />
                </div>
                {account.error && <div style={{ margin: 20, fontSize: 14, color: 'red' }}>
                    {account.error.data}
                </div>}
            </Dialog>
        </div>}

        {user.authType === 'Default' && <div style={{ color: '#3f51b5', marginTop: 40, width: 300, fontSize: 14 }}>
            <div>
                <Button variant={'outlined'} color={'primary'} onClick={() => {
                    showPasswordReset_set(true);
                }}>Reset Password</Button>
            </div>
        </div>}
        {account.passwordResettingSuccess && <div>
            <Dialog title={'Password Reset'} onClose={() => {
                window.location.reload();
            }}>
                <div>
                    <div>Your password has been reset!</div>
                </div>
            </Dialog>
        </div>}
    </div>

}

const mapStateToProps = (state, ownProps) => {
    return {
        account: state.account
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actionsGroupList, dispatch),
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles((theme) => {

})(Main));


// WEBPACK FOOTER //
// ./src/account/components/MyProfile.js